
export class GetUnreadMessagesSummary {
    static readonly type = '[UserMessage] Get Unread Messages Summary';
    constructor(public userId: string) {
    }
}

export class MarkMessageRead {
    static readonly type = '[UserMessage] Mark Message Read';
    constructor(public userId: string, public messageId: string) {
    }
}

export class GetAllMessages {
    static readonly type = '[UserMessage] Get All Messages';
    constructor(public userId: string) {
    }
}

export class ClearUnreadMessageFromState {
    static readonly type = '[UserMessage] Clear Unread Message In State';
    constructor() {
    }
}

export class DeleteUserMessage {
    static readonly type = '[UserMessage] Delete Message for the User';
    constructor(public userMessageId: string, public messageId: string) {
    }
}

export class ClearUserMessageState {
    static readonly type = '[UserMessage] Clear User Message State';
    constructor() {
    }
}

export class GetUnreadMessagesCount {
    static readonly type = '[UserMessage] Get Unread Messages Count';
    constructor(public userId: string) {
    }
}